import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface ContactGroupByIndexRouteModel {
  propertyLabels: string[];
  propertyCount: { [propertyName: string]: number };
}

export default class ContactGroupByIndexRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Contacts Group by Property';
  }

  model(): ContactGroupByIndexRouteModel {
    let model = {
      propertyLabels: ['Groups'],
      propertyCount: {
        Groups: this.contactsCache.contacts.filter((x) => x.hasGroups).length,
      },
    } as ContactGroupByIndexRouteModel;

    for (let customProperty of this.contactsCache.customProperties) {
      if (customProperty.t === 'l' || customProperty.t === 'b') {
        model.propertyLabels.push(customProperty.l);
        model.propertyCount[customProperty.l] =
          this.contactsCache.contacts.filter(
            (x) => x.customPropertiesByLabel[customProperty.l] != null,
          ).length;
      }
    }

    return model;
  }
}
